/* unplugin-vue-components disabled */import { render } from "./MenuSpeachCard.vue?vue&type=template&id=b700283e&scoped=true&ts=true"
import script from "./MenuSpeachCard.vue?vue&type=script&lang=ts"
export * from "./MenuSpeachCard.vue?vue&type=script&lang=ts"

import "./MenuSpeachCard.vue?vue&type=style&index=0&id=b700283e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b700283e"]])

export default __exports__